export function applyExchageRate(value: string, exchangeRate: string) {
  return Math.round(Number(value) * Number(exchangeRate));
}
